import React from 'react';

import LoadingProgress from "../loadingProgress";
import SectionLoadingLine from "../sectionLoadingLine";

import { ElementContainer } from './index.style'

export const CALLING = 0;
export const POPULATED = 1;
export const EMPTY = 2;
export const TIMEOUT = 3;

interface APIStatus {
  status?: number,
  type?: string,
  disable?: string,
}

const ApiStatus: React.FC<APIStatus> = (props) => {
  const { children, status , type, disable, message} = props;
  const loadingElement = type == 'ring' || type == 'bar'? <LoadingProgress size={type}/>: <div/>;

  return (
    <React.Fragment>
      {type == 'section' && <SectionLoadingLine active={status == CALLING}/>}
      {(status == CALLING || status == EMPTY || status == TIMEOUT) && <ElementContainer>
        {status == CALLING && type != 'section' && loadingElement}
        {disable != 'empty' && status == EMPTY && <h2>There were no records found!</h2>}
        {status == TIMEOUT && <h2>This is taking longer than expected. Please try again shortly.</h2>}
        {status == CALLING && message != undefined && <h2>{message}</h2>}
      </ElementContainer>}
      {status == POPULATED && children}
    </React.Fragment>
  )
};

export default ApiStatus;